import React from "react";
import "./project.css";
import IMG1 from '../../assets/IMG1.png';
import IMG2 from '../../assets/IMG2.png';
import IMG3 from '../../assets/IMG3.png';
import IMG4 from '../../assets/IMG4.png';
import IMG5 from '../../assets/IMG5.png';
import IMG6 from '../../assets/IMG6.png';
import IMG7 from '../../assets/IMG7.png';
import IMG8 from '../../assets/IMG8.png';


const projects = [
  {
  id: 1,
  image: IMG1,
  title: 'DeepChat',
  github: 'https://github.com/DeshDeepakKushwaha/DeepChat',
  demo:'https://deepchat.onrender.com/'
},
 {
  id: 2,
  image: IMG2,
  title: 'Joke Teller Text To Speech',
  github: 'https://github.com/DeshDeepakKushwaha/Joke-Teller-Text-To-Speech',
  demo:'https://deshdeepakkushwaha.github.io/Joke-Teller-Text-To-Speech/'
  }, 
 {
  id: 3,
  image: IMG3,
  title: 'Quote Generator',
  github: 'https://github.com/DeshDeepakKushwaha/Quote-Generator',
   demo: 'https://deshdeepakkushwaha.github.io/Quote-Generator/'
  },
 {
  id: 5,
  image: IMG5,
  title: 'Infinte Dog Scroll',
  github: 'https://github.com/DeshDeepakKushwaha/Infinte-Dog-Scroll',
  demo:'https://deshdeepakkushwaha.github.io/Infinte-Dog-Scroll/'
  },
  {
    id: 4,
    image: IMG4,
    title: 'Pig Game',
    github: 'https://github.com/DeshDeepakKushwaha/PigGame',
    demo:'https://deshdeepakkushwaha.github.io/PigGame/'
    },
    {
      id: 6,
      image: IMG6,
      title: '2048 Game',
      github: 'https://github.com/DeshDeepakKushwaha/2048-Game',
      demo:'https://deshdeepakkushwaha.github.io/2048-Game/'
      },
      {
        id: 7,
        image: IMG7,
        title: 'BookMark',
        github: 'https://github.com/DeshDeepakKushwaha/BookMarker',
        demo:'https://deshdeepakkushwaha.github.io/BookMarker/'
        },
        {
          id: 8,
          image: IMG8,
          title: 'Tic Tac Toe',
          github: 'https://github.com/DeshDeepakKushwaha/Tic-Tac-Toe',
          demo:'https://deshdeepakkushwaha.github.io/Tic-Tac-Toe/'
          },
  
]
const Projects = () => {
  return (
    <section id="project" data-aos="zoom-out-up">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <div className="container project_container">
        {projects.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="project_item">
          <div className="project_item-image">
          <img src={image} alt={title} />
          </div>
              <h3>{title}</h3>
          <div className="project-item-cta">
                     <a
            href={github}
            className="btn"
          >
            Github
          </a>
          <a href={demo} className="btn btn-primary" target='_blank' rel="noreferrer">
            Live Demo
          </a>
          </div> 
        </article>
          )
        })}               
      </div>
    </section>
  );
};

export default Projects;
